export const USERS_LIST_REQUEST = 'USERS_LIST_REQUEST';
export const USERS_LIST_REQUEST_SUCCESS = 'USERS_LIST_REQUEST_SUCCESS';
export const USERS_LIST_REQUEST_FAIL = 'USERS_LIST_REQUEST_FAIL';
